/* eslint array-callback-return: 0 */
import { AppIntegrationsRepository, MeRepository, PaymentTypesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', 'UserRestService', '$window', 'Util', 'ChangePaymentUrlsRestService'];

/**
 * @ngdoc controller
 * @name directives.controller.PaymentController
 *
 * @description
 * Payment controller
 */
class PaymentController {

    /**
     * @param  {any} $scope
     * @param  {any} UserRestService
     * @param  {any} $window
     */
    constructor($scope, UserRestService, $window, Util, ChangePaymentUrlsRestService) {

        this.$scope = $scope;
        this.MeRepository = MeRepository;
        this.UserRestService = UserRestService;
        this.$window = $window;
        this.user = MeRepository.getMyUser();
        this.PaymentTypesRepository = PaymentTypesRepository;
        this.Util = Util;
        this.payments = [];
        this.ChangePaymentUrlsRestService = ChangePaymentUrlsRestService;

        const paymentTypesObservable = this.PaymentTypesRepository.getObservable();

        paymentTypesObservable.subscribe(
            (data) => {

                this.payments = data;

            },
            () => { },
            () => { },
        );

        this.payments.map((payment) => {

            payment.appdata =
                AppIntegrationsRepository.getById(payment.relationships.app.data.id);

            // check if the expiration date has this format 2018-11-16T15:02:04+02:00
            if (!payment.attributes.expiration_date || payment.attributes.expiration_date.indexOf('-') === -1) {

                return;

            }

            // notify with 10days before
            const daysBeforeExpiration =
                CWCONFIG.features.paymentTypesDaysBeforeExpiration || 10;
            const now = moment();
            const formatedDate = payment.attributes.expiration_date.split('-');
            if (formatedDate.length > 1) {

                // create a new date at last day of month
                const expirationDate =
                    moment(new Date(Number(formatedDate[0]), Number(formatedDate[1]), 0));
                if (
                    expirationDate.diff(now, 'days') <=
                    daysBeforeExpiration
                ) {

                    payment.expired = true;

                }
                payment.expiration_date = expirationDate.format('MM/YYYY');

            }

        });

    }

    editPayment(payment, $event) {

        angular.element($event.target).addClass('disabled');

        // Fallback link in case the response is null
        let paymentLink = this.Util.deepFind(payment, 'attributes.update_payment');

        const transactionId = this.Util.deepFind(payment, 'id');
        const navigator = this.Util.getDeviceNavigator();
        const browserName = this.$window.browserName.toLowerCase();

        this.ChangePaymentUrlsRestService
            .changePaymentUrlByTransactionId(transactionId).then((response) => {

                if (response.data.data.length > 0) {

                    paymentLink = response.data.data[0].attributes.url;

                }
                angular.element($event.target).removeClass('disabled');

                if (navigator === 'ios' || browserName === 'safari') {

                    this.$window.location.href = paymentLink;

                } else {

                    this.$window.open(paymentLink, '_blank');

                }

            }).then(null, () => {

                angular.element($event.target).removeClass('disabled');

                if (navigator === 'ios' || browserName === 'safari') {

                    this.$window.location.href = paymentLink;

                } else {

                    this.$window.open(paymentLink, '_blank');

                }

            });

        Mixpanel.send('ConnectWeb Edit Payment Click');

    }

    // if user requested to delete their card (last_digits will be empty)
    // then we dont show change payment button
    showChangePaymentButton(payment) {

        return !this.Util.isPaymentCardDeleted(payment);

    }

}

/**
 * @ngdoc directive
 * @name directives.PaymentDirective
 *
 * @description
 * email Payment form directive
 */
class PaymentDirective {

    constructor() {

        this.template = require('./payment.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push((
            $scope, UserRestService, $window,
            Util, ChangePaymentUrlsRestService,
        ) =>
            new PaymentController(
                $scope, UserRestService, $window,
                Util, ChangePaymentUrlsRestService,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'PaymentCtrl';

    }

}

_directiveDependencies.push(() => new PaymentDirective());


angular.module('directives')
    .directive('payment', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/payment/payment.js